import { createApp, nextTick } from 'petite-vue';
import { unescapeHTML } from './utils.js';
const mainEl = document.querySelector('.main');

createApp({
  videos: window.entries,
  currentContent: '',
  currentUser: '',
  currentIndex: 0,
  currentTitle: '',
  ready: false,
  player: null,
  done: false,
  loaded: false,

  async fetchVideos() {
    this.getContent();
  },

  getContent() {
    this.currentContent = unescapeHTML(this.videos[this.currentIndex]?.body);
    this.currentUser = this.videos[this.currentIndex]?.created_user
    const videoContainer = document.createElement('div');
    videoContainer.id = `player-${this.currentIndex}`;
    mainEl.appendChild(videoContainer);

    nextTick(async () => {
      this.player = new YT.Player(`player-${this.currentIndex}`, {
        height: '390',
        width: '640',
        videoId: this.videos[this.currentIndex].youtube_id,
        playerVars: {
          'playsinline': 1
        },
        events: {
          'onReady': this.onPlayerReady,
          'onStateChange': this.onPlayerStateChange
        }
      });
      this.addContent();
    });

  },

  addContent() {
    const prevContainer = document.querySelector('.content-container');
    prevContainer?.remove();

    const contentContainer = document.createElement('div');
    contentContainer.className = 'content-container';
    contentContainer.innerHTML = this.removeLiteYoutubeTags(unescapeHTML(this.currentContent));
    contentContainer.innerHTML += '<p class="posted-by">- ' + this.currentUser + '</p>';
    mainEl.appendChild(contentContainer);
  },


  removeLiteYoutubeTags(content) {
    const regex = /<lite-youtube\s+.*?>.*?<\/lite-youtube>/gs; // Matches the lite-youtube tag and its content
    return content.replace(regex, '');
  },


  onPlayerReady(event) {
    this.loaded = true;
    event.target.playVideo();
    this.currentTitle = this.player.videoTitle
  },

  pauseVideo() {
    this.player.pauseVideo();
  },
  playVideo() {
    this.player.playVideo();
  },

  prevVideo() {

    if (this.currentIndex > 1) {
      this.player = null

      const element = document.getElementById(`player-${this.currentIndex}`);
      element.remove();

      this.currentIndex--;
      this.getContent();
    }
  },
  nextVideo() {
    if (this.currentIndex < this.videos.length - 1) {
      this.player = null

      const element = document.getElementById(`player-${this.currentIndex}`);
      element.remove();

      this.currentIndex++;
      this.getContent();
    }
  },

  getVideoTitle() {
    const d = this.player.getVideoData();
    this.currentTitle = `<p>${d.title}</p>`;
  },

  onPlayerStateChange(event) {
    // if (event.data == YT.PlayerState.PLAYING && !this.done) {
    //   setTimeout(this.stopVideo, 6000);
    //   this.done = true;
    // }

    if (event.data == YT.PlayerState.ENDED) {
      this.loaded = false
      this.player = null

      const element = document.getElementById(`player-${this.currentIndex}`);
      element.remove();

      this.currentIndex++;

      nextTick()
      nextTick()
      nextTick()
      this.getContent();
      // this.onYouTubeIframeAPIReady(this.videos[this.currentIndex].youtube_id, this.currentIndex);
      // this.currentContent = this.removeLiteYoutubeTags(this.videos[this.currentIndex].content);
    }
  },
  stopVideo() {
    this.player.stopVideo();
  },
}).mount();
